import React from "react";
import { techStackDetails } from "../Details";

function Technologies() {
  const {
    html,
    css,
    js,
    react,
    redux,
    bootstrap,
    sass,
    vscode,
    git,
    github,
    tailwind,
    jquery,
    typeScript,
  } = techStackDetails;
  return (
    <main className="container mx-auto max-width pt-10 pb-20 ">
      <section>
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Tech Stack
        </h1>
        <p className="text-content py-2 lg:max-w-3xl">
          Technologies I've been working with recently
        </p>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
        <img src={html} title="html" alt="" className="icon-img" />

        <img src={css} title="CSS" alt="" className="icon-img" />

        <img src={js} title="JavaScript" alt="" className="icon-img" />

        <img src={react} title="React" alt="" className="icon-img" />

        <img src={redux} title="Redux" alt="" className="icon-img" />

        <img src={bootstrap} title="Bootstrap" alt="" className="icon-img" />

        <img src={tailwind} title="tailwind" alt="" className="icon-img" />

        <img src={sass} title="SASS" alt="" className="icon-img" />

        <img src={jquery} title="jquery" alt="" className="icon-img" />

        <img src={typeScript} title="typeScript" alt="" className="icon-img" />
      </section>
      <section>
        <h1 className="text-2xl pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Tools
        </h1>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
        <img src={vscode} title="Visual Studio Code" className="icon-img" alt="" />
        <img src={git} title="Git" className="icon-img" alt="Git" />
        <img src={github} title="Github" className="icon-img" alt="Github" />
      </section>
    </main>
  );
}

export default Technologies;
